export const VALUES = [
  {
    name: 'ACCEPTANCE',
    description: 'to be accepted as I am',
  },
  {
    name: 'ACCURACY',
    description: 'to be accurate in my opinions and beliefs',
  },
  {
    name: 'ACHIEVEMENT',
    description: 'to have important accomplishments',
  },
  {
    name: 'ADVENTURE',
    description: 'to have new and exciting experiences',
  },
  {
    name: 'ATTRACTIVENESS',
    description: 'to be physically attractive',
  },
  {
    name: 'AUTHORITY',
    description: 'to be in charge of and responsible for others',
  },
  {
    name: 'AUTONOMY',
    description: 'to be self-determined and independent',
  },
  {
    name: 'BEAUTY',
    description: 'to appreciate beauty around me',
  },
  {
    name: 'CARING',
    description: 'to take care of others',
  },
  {
    name: 'CHALLENGE',
    description: 'to take on difficult tasks and problems',
  },
  {
    name: 'CHANGE',
    description: 'to have a life full of change and variety',
  },
  {
    name: 'COMFORT',
    description: 'to have a pleasant and comfortable life',
  },
  {
    name: 'COMMITMENT',
    description: 'to make enduring, meaningful commitments',
  },
  {
    name: 'COMPASSION',
    description: 'to feel and act on concern for others',
  },
  {
    name: 'CONTRIBUTION',
    description: 'to make a lasting contribution in the world',
  },
  {
    name: 'COOPERATION',
    description: 'to work collaboratively with others',
  },
  {
    name: 'COURTESY',
    description: 'to be considerate and polite toward others',
  },
  {
    name: 'CREATIVITY',
    description: 'to have new and original ideas',
  },
  {
    name: 'DEPENDABILITY',
    description: 'to be reliable and trustworthy',
  },
  {
    name: 'DUTY',
    description: 'to carry out my duties and obligations',
  },
  {
    name: 'ECOLOGY',
    description: 'to live in harmony with the environment',
  },
  {
    name: 'EXCITEMENT',
    description: 'to have a life full of thrills and stimulation',
  },
  {
    name: 'FAITHFULNESS',
    description: 'to be loyal and true in relationships',
  },
  {
    name: 'FAME',
    description: 'to be known and recognized',
  },
  {
    name: 'FAMILY',
    description: 'to have a happy, loving family',
  },
  {
    name: 'FITNESS',
    description: 'to be physically fit and strong',
  },
  {
    name: 'FLEXIBILITY',
    description: 'to adjust to new circumstances easily',
  },
  {
    name: 'FORGIVENESS',
    description: 'to be forgiving of others',
  },
  {
    name: 'FRIENDSHIP',
    description: 'to have close, supportive friends',
  },
  {
    name: 'FUN',
    description: 'to play and have fun',
  },
  {
    name: 'GENEROSITY',
    description: 'to give what I have to others',
  },
  {
    name: 'GENUINENESS',
    description: 'to act in a manner that is true to who I am',
  },
  {
    name: "GOD'S WILL",
    description: 'to seek and obey the will of God',
  },
  {
    name: 'GROWTH',
    description: 'to keep changing and growing',
  },
  {
    name: 'HEALTH',
    description: 'to be physically well and healthy',
  },
  {
    name: 'HELPFULNESS',
    description: 'to be helpful to others',
  },
  {
    name: 'HONESTY',
    description: 'to be honest and truthful',
  },
  {
    name: 'HOPE',
    description: 'to maintain a positive and optimistic outlook',
  },
  {
    name: 'HUMILITY',
    description: 'to be modest and unassuming',
  },
  {
    name: 'HUMOR',
    description: 'to see the humorous side of myself and the world',
  },
  {
    name: 'INDEPENDENCE',
    description: 'to be free from dependence on others',
  },
  {
    name: 'INDUSTRY',
    description: 'to work hard and well at my life tasks',
  },
  {
    name: 'INNER PEACE',
    description: 'to experience personal peace',
  },
  {
    name: 'INTIMACY',
    description: 'to share my innermost experiences with others',
  },
  {
    name: 'JUSTICE',
    description: 'to promote fair and equal treatment for all',
  },
  {
    name: 'KNOWLEDGE',
    description: 'to learn and contribute valuable knowledge',
  },
  {
    name: 'LEISURE',
    description: 'to take time to relax and enjoy',
  },
  {
    name: 'LOVED',
    description: 'to be loved by those close to me',
  },
  {
    name: 'LOVING',
    description: 'to give love to others',
  },
  {
    name: 'MASTERY',
    description: 'to be competent in my everyday activities',
  },
  {
    name: 'MINDFULNESS',
    description: 'to live consciously and mindfully of the present moment',
  },
  {
    name: 'MODERATION',
    description: 'to avoid excesses and find a middle ground',
  },
  {
    name: 'MONOGAMY',
    description: 'to have one close, loving relationship',
  },
  {
    name: 'NONCONFORMITY',
    description: 'to question and challenge authority and norms',
  },
  {
    name: 'NURTURANCE',
    description: 'to take care of and nurture others',
  },
  {
    name: 'OPENNESS',
    description: 'to be open to new experiences, ideas, and options',
  },
  {
    name: 'ORDER',
    description: 'to have a life that is well-ordered and organized',
  },
  {
    name: 'PASSION',
    description: 'to have deep feelings about ideas, activities, or people',
  },
  {
    name: 'PLEASURE',
    description: 'to feel good',
  },
  {
    name: 'POPULARITY',
    description: 'to be well-liked by many people',
  },
  {
    name: 'POWER',
    description: 'to have control over others',
  },
  {
    name: 'PURPOSE',
    description: 'to have meaning and direction in my life',
  },
  {
    name: 'RATIONALITY',
    description: 'to be guided by reason and logic',
  },
  {
    name: 'REALISM',
    description: 'to see and act realistically and practically',
  },
  {
    name: 'RESPONSIBILITY',
    description: 'to make and carry out responsible decisions',
  },
  {
    name: 'RISK',
    description: 'to take risks and chances',
  },
  {
    name: 'ROMANCE',
    description: 'to have intense, exciting love in my life',
  },
  {
    name: 'SAFETY',
    description: 'to be safe and secure',
  },
  {
    name: 'SELF-ACCEPTANCE',
    description: 'to accept myself as I am',
  },
  {
    name: 'SELF-CONTROL',
    description: 'to be disciplined in my own actions',
  },
  {
    name: 'SELF-ESTEEM',
    description: 'to feel good about myself',
  },
  {
    name: 'SELF-KNOWLEDGE',
    description: 'to have a deep and honest understanding of myself',
  },
  {
    name: 'SERVICE',
    description: 'to be of service to others',
  },
  {
    name: 'SEXUALITY',
    description: 'to have an active and satisfying sex life',
  },
  {
    name: 'SIMPLICITY',
    description: 'to live life simply, with minimal needs',
  },
  {
    name: 'SOLITUDE',
    description: 'to have time and space where I can be apart from others',
  },
  {
    name: 'SPIRITUALITY',
    description: 'to grow and mature spiritually',
  },
  {
    name: 'STABILITY',
    description: 'to have a life that stays fairly consistent',
  },
  {
    name: 'TOLERANCE',
    description: 'to accept and respect those who differ from me',
  },
  {
    name: 'TRADITION',
    description: 'to follow respected patterns of the past',
  },
  {
    name: 'VIRTUE',
    description: 'to live a morally pure and excellent life',
  },
  {
    name: 'WEALTH',
    description: 'to have plenty of money',
  },
  {
    name: 'WORLD PEACE',
    description: 'to work to promote peace in the world',
  },
];
